<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span>
                    Документы
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>
            <v-btn @click="goToEdit" style="width: auto !important" class=" button-action">
                Редактировать
            </v-btn>
        </div>

        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Документы»
                    </div>
                    <div class="menu-container-text">
                        Описание деятельности совета с возможностью прикреплять файлы
                    </div>

                </div>

            </v-card>
        </v-menu>

        <div class="main-container-info-box">
            <div class="info-block" v-if="item.text">
                <div class="info-block-title">
                    Основной текст
                </div>
                <div class="info-block-text">
                    {{ item.text }}
                </div>
            </div>
            <div class="info-block">
                <div class="info-block-title">
                    Вложенные файлы
                </div>
                <div class="info-block-text">
                    <div v-for="(i, index) in item.files" :key="index">
                        <v-icon> mdi-file-pdf-box </v-icon>
                        <a style="margin-left:8px" target="_blank" :href="i.file">{{ i.name }}</a>
                    </div>
                </div>
            </div>
            <div>
                <div class="table-title">
                    Изображение
                    <v-icon @mouseover="openInfoImg($event)" @mouseleave="showInfoImg = false" color="#E0E0E0">
                        mdi-information
                    </v-icon>

                </div>
                <v-menu v-model="showInfoImg" :position-x="xImg" :position-y="yImg" absolute offset-y>
                    <v-card>
                        <div class="menu-container">
                            <div class="menu-container-text">
                                Нажмите на изображение, чтобы увидеть его в полном размере
                            </div>
                        </div>

                    </v-card>
                </v-menu>

            </div>

            <div>
                <v-simple-table v-if="item">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th style="padding-left: 24px" class="text-left">
                                    Формат
                                </th>
                                <th class="text-left">
                                    Место отображенния
                                </th>
                                <th class="text-left">
                                    Для смартфонов
                                </th>
                                <th class="text-left">
                                    Для планшетов
                                </th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr style="height: 60px;">
                                <td style="padding-left: 24px" class="text-left">Иконка раздела</td>
                                <td class="text-left">Изображение на фоне раздела</td>
                                <td class="text-left">
                                    <img @click="openDialogImg(item.smartphoneImage)" v-if="item.smartphoneImage"
                                        class="table-img" :src="item.smartphoneImage">
                                </td>
                                <td class="text-left">
                                    <img @click="openDialogImg(item.tabletImage)" v-if="item.tabletImage" class="table-img"
                                        :src="item.tabletImage">
                                </td>
                            </tr>




                        </tbody>
                    </template>
                </v-simple-table>

                <DialogImage v-model="dialogImg" :src="previewImage" />
                <v-divider></v-divider>
            </div>


        </div>

    </div>
</template>
<script>


export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        item: {},
        dialogImg: false,
        previewImage: null,
        imageWidth: 0,
        showInfoImg: false,
        xImg: null,
        yImg: null,

    }),
    methods: {
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        openInfoImg(e) {
            e.preventDefault()
            this.xImg = e.clientX + 10
            this.yImg = e.clientY + 10
            this.showInfoImg = true

        },
        openDialogImg(src) {
            this.previewImage = src
            this.dialogImg = true
        },
        goToEdit() {
            this.$router.push({ name: 'EditWorkPlan' })

        },

        getActivity() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/activity', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    key: 'workplan'
                }
            })
                .then(res => {
                    this.item = res.data

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },


    },
    created() {
        this.getActivity()
    },
}
</script>
<style lang="scss" scoped>
.main-container {

    .main-container-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 40px 24px;

        .main-container-title-box-text {
            display: flex;
            align-items: center;

            span {
                font-size: 28px;
                font-weight: 400;
                margin-right: 20px;
            }

        }

    }

    .main-container-info-box {
        .table-title {
            font-size: 24px;
            font-weight: 600;
            margin: 0 24px;
        }

        .info-block {
            width: 50%;
            margin: 0 24px;
            margin-bottom: 50px;

            .info-block-title {
                font-size: 24px;
                font-weight: 600;
            }

            .info-block-text {
                font-size: 18px;
                font-weight: 400;
            }
        }

        .table-img {
            cursor: pointer;
            height: 38px;
            object-fit: contain;
        }


    }
}
</style>